<div class="surface-card p-4 border-round shadow-2 mb-4">
  <div class="flex align-items-center justify-content-between mb-4">
    <div class="flex align-items-center">
      <i class="pi pi-history text-primary text-xl mr-2"></i>
      <h2 class="text-xl font-semibold text-900 m-0">Audit Log</h2>
    </div>
    <button
      pButton
      icon="pi pi-external-link"
      styleClass="p-button-text p-button-sm"
      pTooltip="View Full Log"
      (click)="viewFullAuditLog()"
    ></button>
  </div>

  <!-- Loading State -->
  <div *ngIf="loading" class="flex justify-content-center p-4">
    <p-progressSpinner strokeWidth="4" animationDuration=".5s"></p-progressSpinner>
  </div>

  <!-- No Data State -->
  <div *ngIf="!loading && auditLogs.length === 0" class="text-center p-4">
    <i class="pi pi-info-circle text-400 text-xl mb-2"></i>
    <p class="text-600 m-0">No audit log entries found</p>
  </div>

  <!-- Audit Log Entries -->
  <div *ngIf="!loading && auditLogs.length > 0" class="flex flex-column gap-3">
    <div *ngFor="let log of auditLogs" class="flex align-items-center p-3 surface-100 border-round">
      <div class="flex-1">
        <div class="text-900 font-medium">{{ getActionDisplayName(log) }}</div>
        <div class="text-600 text-sm">
          <span *ngIf="log.context">{{ log.context }}</span>
          <span *ngIf="log.context"> - </span>
          {{ getTimeAgo(log.action_date) }}
        </div>
      </div>
      <p-tag
        [value]="getActionCategory(log)"
        [severity]="getSeverityColor(log.action_type).replace('bg-', '').replace('-500', '')"
      ></p-tag>
    </div>
  </div>
</div>
